/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import {FC, useEffect, useState} from 'react'
import {NavLink, useParams} from 'react-router-dom'
import {MenuComponent} from '../../../../../../_metronic/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../_metronic/helpers'
import useUser from '../../../../../hooks/useUser'
import axios from 'axios'
import {BASE_URL} from '../../../../../../api'
type Props = {
  id: ID
  role: string
}

const UserActionsCell: FC<Props> = ({id, role}) => {
  // @ts-ignore

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const [activate, setActivate] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')
  const [showModal2, setShowModal2] = useState(false)

  const handleSwitch = () => {
    switch (activate) {
      case false:
        if (role === 'INDIVIDUAL') {
          setMessage('Are you sure you want to approve this users premium request for 12 months?')
        } else {
          setMessage('Please Select Subscription type')
        }

        setShowModal(true)
        break
      case true:
        setMessage('Are you sure you want to decline this users premium request?')
        setShowModal(true)
        break
      default:
        break
    }
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <NavLink to={`/apps/agents/details-page/${id}/bookings`} className='menu-link px-3'>
            View
          </NavLink>
        </div>

        <div className='menu-item px-3'>
          <div
            onClick={() => {
              console.log('delete ' + id)
              setShowModal2(true)
            }}
            className='menu-link px-3'
          >
            Delete
          </div>
        </div>

        {/* end::Menu item */}

        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
      {showModal && <MessageModal id={id} showModal={showModal} setShowModal={setShowModal} />}
      {showModal2 && (
        <DeleteModal
          id={id}
          activate={activate}
          showModal={showModal2}
          setShowModal={setShowModal2}
          setActivate={setActivate}
          message={message}
          accountType={role}
          setMessage={setMessage}
        />
      )}
    </>
  )
}

const MessageModal = ({
  showModal,
  setShowModal,
  message,
  setMessage,
  activate,
  setActivate,
  accountType,
}: any) => {
  const {id} = useParams()

  const [duration, setDuration] = useState<any>('')
  const {updatePremiumRequest} = useUser()
  const handleStatusChange = async () => {
    try {
      const premium_request = activate ? 'approved' : 'declined'
      const response = await updatePremiumRequest(id, premium_request, duration)
      console.log(response, 'respones-here')
      setActivate((pv: boolean) => !pv)
    } catch (error) {
      console.log(error)
    } finally {
      setShowModal(false)
    }
  }
  return (
    <>
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'> {activate ? 'Decline' : 'Approve'}</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={() => setShowModal(false)}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                  {accountType === 'BUSINESS' && (
                    <>
                      <div className='form-check form-check-inline'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='duration'
                          id='duration6'
                          value='6'
                          checked={duration === 6}
                          onChange={(e) => setDuration(parseInt(e.target.value))}
                        />
                        <label className='form-check-label' htmlFor='duration6'>
                          6 months
                        </label>
                      </div>
                      <div className='form-check form-check-inline'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='duration'
                          id='duration12'
                          value='12'
                          checked={duration === 12}
                          onChange={(e) => setDuration(parseInt(e.target.value))}
                        />
                        <label className='form-check-label' htmlFor='duration12'>
                          12 months
                        </label>
                      </div>
                    </>
                  )}
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => setShowModal(false)}
                    data-bs-dismiss='modal'
                  >
                    No
                  </button>
                  <button onClick={handleStatusChange} type='button' className='btn btn-primary'>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

const DeleteModal = ({showModal, setShowModal, message, id}) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const deleteUserById = async (userId: string) => {
    try {
      setError(false)
      setLoading(true)
      await axios.delete(`${BASE_URL}/admin/users/${userId}`)
    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false)
      setShowModal(false)
      window.location.reload()
    }
  }

  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{'Delete User'}</h5>
                  {/* <div
                      className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                      data-bs-dismiss='modal'
                      aria-label='Close'
                      onClick = {()=> setShowModal(false)}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr061.svg'
                        className='svg-icon svg-icon-2x'
                      />
                    </div> */}
                </div>
                <div className='modal-body fs-3'>
                  <p>
                    {error
                      ? 'Something went wrong, please try again'
                      : ' Are you sure you want to delete this user ?'}
                  </p>
                </div>
                <div className='modal-footer'>
                  {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                      Close
                    </button> */}
                  <button
                    onClick={() => {
                      setShowModal(false)
                      // window.location.reload()
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>

                  {!error && (
                    <button
                      onClick={() => {
                        deleteUserById(id)
                      }}
                      type='button'
                      className='btn btn-danger'
                      disabled={loading}
                    >
                      {loading ? 'Please wait...' : 'Delete'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

export {UserActionsCell}
